import React, { useState, useEffect } from "react";
import ThemePicker from "./ThemePicker";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL, API_URL } from "../config";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { logout, selectUser, setSidebarCollapsed, selectSidebarCollapsed } from "../store/auth/authSlice";
import { revokeSession } from "../../setupAxiosInterceptors";
import { getSessionToken } from "../cms/utils/session";

const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authUser = useSelector(selectUser);
  const sidebarCollapsed = useSelector(selectSidebarCollapsed);
  const userName = authUser?.user?.name || authUser?.user?.email || "Admin";
  /* The refresh token outlives the browser session by seven days, so logging out
     has to tell the server too — otherwise a key that still works is left behind
     on a shared machine. The local session is cleared either way; a revoke that
     fails must not keep someone on a screen they are trying to leave. */
  const handleLogout = async () => {
    await revokeSession();
    dispatch(logout());
    navigate("/cms/login");
    localStorage.clear();
  };
  const [token, setToken] = useState(getSessionToken());
  const [logo, setLogo] = useState("");

  useEffect(() => {
    setToken(getSessionToken());
    websitelogo();
  }, []);

  const websitelogo = async () => {
    try {
      const logo = await axios.get(API_BASE_URL+'/get-web-company-profile');
      const weblogo = JSON.parse(JSON.stringify(logo.data));
      if (weblogo.status == 200) {
        // console.log(weblogo, "weblogo");
        setLogo(weblogo.data.logo);
        localStorage.setItem("logo_url", weblogo.data.logo);
      }
    } catch (e) {
      return false;
    }
  };

  return (
    <header id="page-topbar">
      <div className="navbar-header">
        <div className="d-flex">
          <div className="navbar-brand-box" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 8px 0 16px" }}>
            <Link to={'/cms/home'} className="logo logo-dark">
              <span className="logo-sm">
                <img src={logo} alt="" height="30" />
              </span>
              <span className="logo-lg">
                <img src={`${logo}`} alt="" height="34" />
              </span>
            </Link>

            <a href="" className="logo logo-light">
              <span className="logo-sm">
                <img src={`${API_URL}${logo}`} alt="" height="30" />
              </span>
              <span className="logo-lg">
                <img src={`${logo}`} alt="" height="34" />
              </span>
            </a>

            <button
              type="button"
              id="vertical-menu-btn"
              onClick={() => dispatch(setSidebarCollapsed(!sidebarCollapsed))}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#6b7280",
                fontSize: 20,
                padding: "4px 6px",
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                lineHeight: 1,
              }}
            >
              <i className="fa fa-fw fa-bars" />
            </button>
          </div>

          {/* <form className="app-search d-none d-lg-block">
                                <div className="position-relative">
                                    <input type="text" className="form-control" placeholder="Search..."/>
                                    <span className="bx bx-search-alt"></span>
                                </div>
                            </form> */}

          {/* <div className="dropdown dropdown-mega d-none d-lg-block ms-2">
                                <button type="button" className="btn header-item waves-effect" data-bs-toggle="dropdown" aria-haspopup="false" aria-expanded="false">
                                    <span key="t-megamenu">Mega Menu</span>
                                    <i className="mdi mdi-chevron-down"></i> 
                                </button>
                                <div className="dropdown-menu dropdown-megamenu">
                                    <div className="row">
                                        <div className="col-sm-8">        
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <h5 className="font-size-14" key="t-ui-components">UI Components</h5>
                                                    <ul className="list-unstyled megamenu-list">
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-lightbox">Lightbox</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-range-slider">Range Slider</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-sweet-alert">Sweet Alert</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-rating">Rating</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-forms">Forms</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-tables">Tables</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-charts">Charts</a>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div className="col-md-4">
                                                    <h5 className="font-size-14" key="t-applications">Applications</h5>
                                                    <ul className="list-unstyled megamenu-list">
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-ecommerce">Ecommerce</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-calendar">Calendar</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-email">Email</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-projects">Projects</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-tasks">Tasks</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-contacts">Contacts</a>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div className="col-md-4">
                                                    <h5 className="font-size-14" key="t-extra-pages">Extra Pages</h5>
                                                    <ul className="list-unstyled megamenu-list">
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-light-sidebar">Light Sidebar</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-compact-sidebar">Compact Sidebar</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-horizontal">Horizontal layout</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-maintenance">Maintenance</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-coming-soon">Coming Soon</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-timeline">Timeline</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-faqs">FAQs</a>
                                                        </li>
                                
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <h5 className="font-size-14" key="t-ui-components">UI Components</h5>
                                                    <ul className="list-unstyled megamenu-list">
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-lightbox">Lightbox</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-range-slider">Range Slider</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-sweet-alert">Sweet Alert</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-rating">Rating</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-forms">Forms</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-tables">Tables</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript:void(0);" key="t-charts">Charts</a>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div className="col-sm-5">
                                                    <div>
                                                        <img src="assets/images/megamenu-img.png" alt="" className="img-fluid mx-auto d-block"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div> */}
        </div>

        <div className="d-flex">
          {/* 
                        <div className="dropdown d-inline-block d-lg-none ms-2">
                            <button type="button" className="btn header-item noti-icon waves-effect" id="page-header-search-dropdown"
                            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="mdi mdi-magnify"></i>
                            </button>
                            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                                aria-labelledby="page-header-search-dropdown">
        
                                <form className="p-3">
                                    <div className="form-group m-0">
                                        <div className="input-group">
                                            <input type="text" className="form-control" placeholder="Search ..." aria-label="Recipient's username"/>
                                            <div className="input-group-append">
                                                <button className="btn btn-primary" type="submit"><i className="mdi mdi-magnify"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div> */}

          <ThemePicker />

          <div className="dropdown d-inline-block">
            <button
              type="button"
              className="btn header-item waves-effect"
              id="page-header-user-dropdown"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {/* <img className="rounded-circle header-profile-user" src="assets/images/users/avatar-1.jpg"
                                    alt="Header Avatar"/> */}
              <span className="d-none d-xl-inline-block ms-1" key="t-henry">
                {/* Henry */}
                {userName} <i className="bx bx-user-pin font"></i>
              </span>

              <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </button>
            <div className="dropdown-menu dropdown-menu-end">
              {/* <a className="dropdown-item" href="#"><i className="bx bx-user font-size-16 align-middle me-1"></i> <span key="t-profile">Profile</span></a>
                                <a className="dropdown-item" href="#"><i className="bx bx-wallet font-size-16 align-middle me-1"></i> <span key="t-my-wallet">My Wallet</span></a>
                                <a className="dropdown-item d-block" href="#"><span className="badge bg-success float-end">11</span><i className="bx bx-wrench font-size-16 align-middle me-1"></i> <span key="t-settings">Settings</span></a>
                                <a className="dropdown-item" href="#"><i className="bx bx-lock-open font-size-16 align-middle me-1"></i> <span key="t-lock-screen">Lock screen</span></a> */}
              <div className="dropdown-divider"></div>
              <button
                // to={"/login"}
                className="dropdown-item text-danger"
                onClick={()=>navigate('/cms/profile')}
              >
                <i className="bx bx-user font-size-16 align-middle me-1 text-success"></i>{" "}
                <span key="t-profile" className="text-success">Profile</span>
              </button>

              <div className="dropdown-divider"></div>
              <button
                //to={"/login"}
                className="dropdown-item text-danger"
                onClick={handleLogout}
              >
                <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>{" "}
                <span key="t-logout">Logout</span>
              </button>
            </div>
          </div>

          {/* <div className="dropdown d-inline-block">
            <button
              type="button"
              className="btn header-item noti-icon right-bar-toggle waves-effect"
            >
              <i className="bx bx-cog bx-spin"></i>
            </button>
          </div> */}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
